module.exports = __webpack_public_path__ + "static/media/wings goal.e90f50aa.png";